import { createRoute } from '@tanstack/react-router'
import { rootRoute } from './root'
import { NotificationsPage } from '../features/notifications/page'

export const notificationsRoute = createRoute({
  path: 'notifications',
  getParentRoute: () => rootRoute,
  component: NotificationsPage,
})
